import Vue from 'vue'
import VueRouter from 'vue-router'
import RouterConfig from './modules' // 引入业务逻辑模块
Vue.use(VueRouter)
import store from "../store"
import { navApi } from "../../static/js/api"
import { localUserInfo } from '../../static/js/utility/utility'

const router = new VueRouter({
  scrollBehavior: () => ({ y: 0 }),
  routes: RouterConfig
})

/** 路由meta参数说明
 * @param {number}  rv        --必填：APP.vue当前访问的<route-view>
 * @param {string}  title     --选填：页面标题
 * @param {number}  psdWidth  --选填：设计稿尺寸（需计算rem时）
 */

router.beforeEach(async (to, from, next) => {
  // console.log('to', to)
  // console.log('from', from)
  
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  /* 根据psdWidth计算rem值 */
  if (to.meta.psdWidth) {
    let psdWidth = to.meta.psdWidth
     // 计算html的font-size
    function getRem (pwidth, prem) {
      let html = document.getElementsByTagName('html')[0]
      let oWidth = document.body.clientWidth || document.documentElement.clientWidth
      let fontSize = oWidth / pwidth * prem
      html.style.fontSize = fontSize + 'px'
      store.state.htmlFontSize = fontSize
      // console.log('当前屏幕宽度', oWidth)
      // console.log('当前font-size', fontSize)
    }
    getRem(psdWidth, 100)
    window.onresize = function () {
      store.state.isOnresize = !(store.state.isOnresize)
      // 监听屏幕变化
      getRem(psdWidth, 100)
    }
  }

  if (localUserInfo.getItem()) {
    store.state.eUserInfo = localUserInfo.getItem();

    if (!store.state.routes) {
      await initMenu(router, store)
    }
    
  }

  next()
})

const initMenu = async(router, store) => {
  console.log('router index initment');

  let userInfo = store.state.eUserInfo;
  let menuList = [];
  await navApi.getUserAuthList().then(resp => {
    console.log('resp', resp)
    if (resp && resp.meta.code == 200) {
      // store.state.routes = resp.data
      menuList = resp.data;
    }
  });

  if (menuList.length) {
    for (let [index, item] of menuList.entries()) {
      for (let [subIndex, subItem] of item.children.entries()) {
        if (subItem.function_tab == 'CBaseStation' && subItem.function_soft != '') {
          let separate = '&';
          if (!subItem.function_soft.includes('?')) {
            separate = '?';
          }
          let url = subItem.function_soft + separate + 'companyId=' + userInfo.company_id;
          menuList[index].children[subIndex].function_soft = url;
          break;
        }
      }
    }

    store.commit('initMenu', menuList);
  }
  
};

export default router


// WEBPACK FOOTER //
// ./src/router/index.js